import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as promotionActions from './../../../../actions/promotionAction';
import Promotions from './Promotions';

const mapStateToProps = state => {
    return {
        promotionState: state.promotionReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListPromotions: (filters) => dispatch(promotionActions.getListPromotions(filters)),
        changeStatusCode: (id, bundleName, note, status, filters) => dispatch(promotionActions.changeStatusCode(id, bundleName, note, status, filters)),
        getAllCampaign: () => dispatch(promotionActions.getAllCampaign()),
        getBundlesByCampaignId: (campaignId) => dispatch(promotionActions.getBundlesByCampaignId(campaignId)),
        exportExcel: (filters) => dispatch(promotionActions.exportExcel(filters)),
        getHistoryCode: (filters) => dispatch(promotionActions.getHistoryCode(filters)),
        resetHistoryCode: () => dispatch(promotionActions.resetHistoryCode()),
        bulkUpdatePromotionStatus: (params, filters) => dispatch(promotionActions.bulkUpdatePromotionStatus(params, filters)),
        // Bundles
        getListBundle: (filters) => dispatch(promotionActions.getListBundles(filters)),
        changeBundleStatus: (bundle) => dispatch(promotionActions.changeBundleStatus(bundle)),

        clearStatusGroup: () => dispatch(promotionActions.clearStatusGroup()),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Promotions));
